import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { IconTrash } from '@tabler/icons-react';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import axios from "../../../library/axios";
import { MySwal } from '../../../library/swal';
import SelectInstruments from "react-select";
import Button from "react-bootstrap/Button";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const DocumentScoresComp = (props) => {
    // console.log(props)
    const [elementPenilaian, setElementPenilaian] = useState([]);
    const [role, setRole] = useState("");
    const [scores, setScores] = useState([]);
    const [scoreIdsToAdd, setScoreIdsToAdd] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    const fetchOneUser = async () => {
        try {
            const options = {
                url: `/users/detailUser`,
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                },
            };
            const { data } = await axios(options);
            setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
        } catch (err) {
            notifyApiLoadError(err, 'components/moleculs/document-scores/index.fetchOneUser');
        }
    };

    const fetchData = async () => {
        try {
            const options = {
                url: `/doc-scores/document/${props?.documentId}`,
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                },
            };
            const { data } = await axios(options);
            // console.log(data)
            // return false
            setElementPenilaian(data);
        } catch (err) {
            notifyApiLoadError(err, 'components/moleculs/document-scores/index.fetchData');
        }
    };

    const normalizeEpSearch = (str) => (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    const filterEpOption = (option, input) =>
        !input || normalizeEpSearch(option.label).includes(normalizeEpSearch(input));

    const fetchScores = async () => {
        try {
            const options = {
                url: `/skor/by-kegiatan/${props?.idKegiatanAkreditasi}`,
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                },
            };
            const { data } = await axios(options);
            setScores(
                data.map((d) => ({
                    label: `${d?.variables_accreditation?.elements_accreditation?.Nomor}${d?.variables_accreditation?.Abjad}`,
                    value: d.id,
                }))
            );
        } catch (err) {
            notifyApiLoadError(err, 'components/moleculs/document-scores/index.fetchScores');
        }
    };

    useEffect(() => {
        fetchData();
        fetchOneUser();
        if (props?.idKegiatanAkreditasi) fetchScores();
    }, []);

    const mappedSkorIds = elementPenilaian.map((row) => row?.skor?.id);

    const handleAddMapping = () => {
        if (scoreIdsToAdd.length === 0) return;
        setSubmitting(true);
        axios({
            url: "/doc-scores",
            method: "POST",
            data: {
                idDocument: props?.documentId,
                skorIds: scoreIdsToAdd.map((item) => item.value),
            },
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then((res) => {
                setSubmitting(false);
                if (res.status === 200) {
                    MySwal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Berhasil menambahkan Elemen Penilaian terkait dokumen!",
                    });
                    setScoreIdsToAdd([]);
                    fetchData();
                }
            })
            .catch((err) => {
                setSubmitting(false);
                if (err !== "") {
                    console.log(err?.response);
                    MySwal.fire({
                        icon: "error",
                        title: "Oops, Error!",
                        text: getApiErrorMessage(err),
                    });
                }
            });
    };

    const columns = [
        {
            name: 'Elemen Penilaian',
            selector: (row) => `${row?.skor?.variables_accreditation?.elements_accreditation?.Nomor} ${row?.skor?.variables_accreditation?.Abjad}`,
        },
        {
            name: 'Aksi',
            cell: (row) => (
                <>
                    {role === "Kelompok Kerja" && props?.isIdBabExist && (
                        <button
                            className="btn btn-outline-warning btn-sm"
                            type="button"
                            title="Hapus"
                            onClick={() => handleDelete(row.id)}
                        >
                            <IconTrash stroke={2} />
                        </button>
                    )}
                </>
            ),
        },
    ];

    const handleDelete = (id) => {
        MySwal.fire({
            title: "Apakah anda yakin ?",
            text: "Data akan dihapus permanen",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#26D07C",
            cancelButtonColor: "#191919",
            confirmButtonText: "Ya, Lakukan!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    url: `/doc-scores/${id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
                })
                    .then(res => {
                        // console.log(res)
                        // return false
                        if (res.status === 200) {
                            MySwal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Berhasil menghapus data!'
                            })

                            fetchData()
                        }
                    })
                    .catch(err => {
                        if (err !== "") {
                            console.log(err?.response?.data?.message)
                            MySwal.fire({
                                icon: 'error',
                                title: 'Oops, Error!',
                                text: getApiErrorMessage(err)
                            })
                        }
                    })
            }
        });
    }

    // console.log(elementPenilaian)

    return (
        <div>
            {role === "Kelompok Kerja" && props?.isIdBabExist ? (
                <div className="mb-3 row">
                    <label className="col-sm-12 col-form-label">
                        Tambahkan Elemen Penilaian Lain
                    </label>
                    <div className="col-12">
                        <SelectInstruments
                            value={scoreIdsToAdd}
                            onChange={setScoreIdsToAdd}
                            options={scores.filter((s) => !mappedSkorIds.includes(s.value))}
                            filterOption={filterEpOption}
                            placeholder="Cari.."
                            isMulti={true}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                        <small className="text-info">
                            Pilih Elemen Penilaian lain yang juga terkait dengan dokumen ini.
                        </small>
                    </div>
                    <div className="col-12 mt-2">
                        <Button
                            variant="success"
                            size="sm"
                            disabled={submitting || scoreIdsToAdd.length === 0}
                            onClick={handleAddMapping}
                        >
                            {submitting ? "Mohon Tunggu.." : "Tambah"}
                        </Button>
                    </div>
                </div>
            ) : (
                ""
            )}
            <DataTable
                columns={columns}
                data={elementPenilaian}
                pagination
                fixedHeader
                highlightOnHover
            />
        </div>
    )
}

export default DocumentScoresComp
